import React from "react"
import { useSelector} from "react-redux"
import { useLocation} from 'react-router-dom'
import CustomLink from "../../CustomLink"
import CustomButton from "../../CustomButton"
import { GA_EVENTS } from "../../../../constants/analytics"
import { useIntl } from "react-intl"
import classNames from "classnames"

// Hooks
import { useLogout } from "../../../../hooks/useLogout"

const GeneralSettingsSidebar = ({ back = () => {} }) => {
  const { formatMessage } = useIntl()
  const auth = useSelector((state) => state.auth)
  const { handleLogout } = useLogout()
  const { pathname } = useLocation()

  const atsEnabled = auth?.atsEnabled && auth.role?.role === "TeamOwner"

  const items = [
    {
      name: backSvg,
      onClick: back,
      trackingEvent: GA_EVENTS.SIDE_BAR.BACK,
      isBack: true
    },
    // {
    //   name: formatMessage({ id: "sidebar.teamMembers" }),
    //   path: "/manage-team",
    //   trackingEvent: GA_EVENTS.SIDE_BAR.TEAM_MEMBERS,
    // },
    {
      name: formatMessage({ id: "sidebar.settings" }),
      path: "/settings",
      trackingEvent: GA_EVENTS.SIDE_BAR.SETTINGS,
    },
    atsEnabled && {
      name: formatMessage({ id: "sidebar.connectToATS" }),
      path: "/ats-integration",
      trackingEvent: GA_EVENTS.SIDE_BAR.CONNECT_TO_ATS,
    },
    auth.role?.role === "TeamOwner" && {
      name: formatMessage({ id: "sidebar.planAndBilling" }),
      path: "/plan-and-billing",
      trackingEvent: GA_EVENTS.SIDE_BAR.PLAN_AND_BILLING,
    },
    {
      name: formatMessage({ id: "sidebar.logout" }),
      onClick: handleLogout,
      trackingEvent: GA_EVENTS.SIDE_BAR.LOGOUT
    },
  ].filter(Boolean)

  return (
    <div className="general-settings">
      {items.map((item) => {
        const isSelected = item.path ? pathname === item.path : false

        return item.onClick ? (
          <CustomButton
            key={`sidebar-${item.name}`}
            className={classNames("general-settings__item", {
              "selected": isSelected
            })}
            onClick={item.onClick}
            trackingEvent={item.trackingEvent ?? GA_EVENTS.GENERAL.SIDE_BAR_CLICKED}
          >
            {item.name}
          </CustomButton>
        ) : (
          <CustomLink
            key={`sidebar-${item.name}`}
            to={item.path}
            className={classNames("general-settings__item", {
              "selected": isSelected
            })}
            trackingEvent={item.trackingEvent ?? GA_EVENTS.GENERAL.SIDE_BAR_CLICKED}
          >
            {item.name}
          </CustomLink>
        )
      })}
    </div>
  )
}

const backSvg = (
  <svg
    width="58"
    height="54"
    viewBox="0 0 58 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="58" height="54" rx="27" fill="#5EC58F" />
    <path
      d="M36 27H22M22 27L29 34M22 27L29 20"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default GeneralSettingsSidebar